export function getStatus(status, stat) {
	const selected = status?.find((s) => +s.id_status === +stat);
	if (selected) return { url: selected.icon, title: selected.label };
	else return { url: '', title: 'Ugyldig status' };

	// const aZ_url = 'https://bdsstrg.blob.core.windows.net/bds-docs-public/';
	// let imgUrl = '';
	// let title = '';
	// if (stat === 9) {
	// 	imgUrl = `${aZ_url}image/new-product-status.png`;
	// 	title = 'Ny';
	// } else if (stat === 2 && pref === 12) {
	// 	//Project
	// 	imgUrl = `${aZ_url}image/waiting-product-status.png`;
	// 	title = 'Venter igangsettelse';
	// } else if (stat === 2 && pref != 12) {
	// 	//Component
	// 	imgUrl = `${aZ_url}image/waiting-product-status.png`;
	// 	title = 'Venter kontroll';
	// } else if (stat === 3 && pref === 12) {
	// 	//Project
	// 	imgUrl = `${aZ_url}image/waiting-product-status.png`;
	// 	title = 'Igangsatt';
	// } else if (stat === 3 && pref != 12) {
	// 	//Component
	// 	imgUrl = `${aZ_url}image/waiting-product-status.png`;
	// 	title = 'Venter Godkjenning';
	// } else if (stat === 4 && pref != 12) {
	// 	//Project
	// 	imgUrl = `${aZ_url}image/approved-product-status.png`;
	// 	title = 'Godkjent';
	// } else if (stat === 4 && pref === 12) {
	// 	//Component
	// 	imgUrl = `${aZ_url}image/approved-product-status.png`;
	// 	title = 'Avsluttet';
	// } else if (stat === 5) {
	// 	imgUrl = `${aZ_url}image/cancelled-product-status.png`;
	// 	title = 'Avslått';
	// } else if (stat === 1) {
	// 	imgUrl = `${aZ_url}image/default-product-status.png`;
	// 	title = 'Status mangler';
	// } else if (stat === 6) {
	// 	imgUrl = `${aZ_url}image/default-product-status.png`;
	// 	title = 'Kontrollert';
	// } else {
	// 	imgUrl = `${aZ_url}image/default-product-status.png`;
	// 	title = 'Open';
	// }
}
